import { call, put, takeEvery } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import { DeclineCustomerInvite, EndPartnershipWithCustomer } from 'src/constants/actionTypes'
import { ApiService, callSecureApi } from '../api/callApi'
import { Endpoints } from 'src/constants/endpoints'

interface DeclineCustomerInvitePayload {
  customerId: string
}

function* onDeclineCustomerInvite(action: AsyncAction<DeclineCustomerInvitePayload>) {
  const { customerId } = action.payload

  try {
    yield call(callSecureApi, Endpoints.DeclineCustomerInvite, {
      method: 'POST',
      apiService: ApiService.Paraworks,
      body: {
        customerId,
      },
    })

    yield put(DeclineCustomerInvite.success())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    const errorMessage = err?.payload?.message || 'Failed to decline customer invite'

    yield put(DeclineCustomerInvite.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

interface EndPartnershipWithCustomerPayload {
  customerId: string
}

function* onEndPartnershipWithCustomer(action: AsyncAction<EndPartnershipWithCustomerPayload>) {
  const { customerId } = action.payload

  try {
    yield call(callSecureApi, Endpoints.EndPartnershipWithCustomer, {
      method: 'POST',
      apiService: ApiService.Paraworks,
      body: {
        customerId,
      },
    })

    yield put(EndPartnershipWithCustomer.success())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    const errorMessage = err?.payload?.message || 'Failed to end partnership with customer '

    yield put(EndPartnershipWithCustomer.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* customerSharedSaga() {
  yield takeEvery(DeclineCustomerInvite.type.REQUEST, onDeclineCustomerInvite)
  yield takeEvery(EndPartnershipWithCustomer.type.REQUEST, onEndPartnershipWithCustomer)
}
